var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeopleToVisitSuccessIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 74,
    viewBox: "0 0 87 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 31.5,
    r: 31.5,
    fill: "#D0FFF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.0623 28L53.5318 36.5304L49 31.7079",
    stroke: "#00DEA3",
    strokeWidth: 2.54206,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2732 54.7616C37.5781 52.4443 41.2387 47.6586 41.2387 42.1256C41.2387 34.3366 33.9984 28 25.1004 28C16.2025 28 8.96217 34.3373 8.96217 42.1256C8.96217 47.6579 12.6228 52.4443 17.9277 54.7616C1.10734 58.2328 0.0100061 73.6561 0 73.8312L2.4982 73.94C2.53989 73.2189 3.79316 56.252 25.0996 56.252C46.406 56.252 47.6593 73.2182 47.7018 73.94L50.2 73.8312C50.19 73.6561 49.0927 58.2328 32.2732 54.7616ZM11.4629 42.1256C11.4629 35.5438 17.58 30.1896 25.0996 30.1896C32.6192 30.1896 38.7363 35.5438 38.7363 42.1256C38.7363 48.7074 32.6192 54.0624 25.0996 54.0624C17.58 54.0624 11.4629 48.7074 11.4629 42.1256Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleToVisitSuccessIcon);
export default __webpack_public_path__ + "static/media/people-to-visit-success-icon.eacf89f504cea0902debb2d8e74b70f8.svg";
export { ForwardRef as ReactComponent };